import Alpine from "alpinejs";
import ProductImages from ":/components/ProductImages";

Alpine.data('ProductImages', ProductImages)
